export const MAX_FILE_SIZE = 10000000;
export const MAX_FILE_SIZE_TEXT = '10 MB';

export const LEARN_MORE_LINK =
    'https://support.approvalmax.com/portal/en/kb/articles/how-to-upload-manual-journal-to-approvalmax';
export const DOWNLOAD_TEMPLATE_LINK =
    'https://workdrive.zohoexternal.com/external/8015f3815f68b753324a6bda1a704c15609904790dc32d00bbb3f7e2bedd48d3';

export const rules = ['rulesItemText1', 'rulesItemText2', 'rulesItemText3', 'rulesItemText4'] as const;
